var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInboxAllFill = function SvgInboxAllFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13q.6 0 1.088-.325.487-.325.737-.875a1 1 0 0 1 .35-.575A.96.96 0 0 1 16.8 11H20V4H8v7h3.2q.35 0 .625.213.275.212.35.562.125.6.65.912T14 13m-6 5q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 16V4q0-.824.588-1.412A1.93 1.93 0 0 1 8 2h12q.824 0 1.413.587Q22 3.176 22 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm-4 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20V7q0-.424.288-.713A.97.97 0 0 1 3 6q.424 0 .712.287Q4 6.576 4 7v13h13q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 17 22z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInboxAllFill);
export { ForwardRef as ReactComponent };